import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@env/insitestore360';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Disable console logs in production
if (environment.production && environment.disableConsoleLogs) {
  // Override all console methods to be no-ops in production
  console.log = () => { };
  console.info = () => { };
  console.warn = () => { };
  console.debug = () => { };
  console.trace = () => { };
  console.table = () => { };
  console.group = () => { };
  console.groupEnd = () => { };
  console.groupCollapsed = () => { };
  console.time = () => { };
  console.timeEnd = () => { };
  console.timeLog = () => { };
  console.count = () => { };
  console.countReset = () => { };
  console.clear = () => { };

  // Keep console.error for critical errors but filter out non-critical ones
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const message = args[0];
    if (typeof message === 'string' &&
      (message.includes('Minified React error #31') ||
        message.includes('inspector.b9415ea5.js') ||
        message.includes('[object Promise]') ||
        message.includes('reactjs.org/docs/error-decoder') ||
        message.includes('Non-Error promise rejection') ||
        message.includes('ResizeObserver loop limit exceeded'))) {
      return;
    }
    // Only log critical errors in production
    if (typeof message === 'string' &&
      (message.includes('ERROR') ||
        message.includes('FATAL') ||
        message.includes('CRITICAL'))) {
      originalConsoleError.apply(console, args);
    }
  };
}

// Suppress DevTools errors before bootstrapping
if (typeof window !== 'undefined') {
  // Override window.onerror
  const originalOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (typeof message === 'string' &&
      (message.includes('Minified React error #31') ||
        message.includes('inspector.b9415ea5.js') ||
        message.includes('[object Promise]') ||
        message.includes('ResizeObserver loop limit exceeded'))) {
      return true;
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
